import { render } from "./OrderDetail.vue?vue&type=template&id=d5e42c64&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=ts"
export * from "./OrderDetail.vue?vue&type=script&lang=ts"

import "./OrderDetail.vue?vue&type=style&index=0&id=d5e42c64&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d5e42c64"

export default script